import React, { useState } from 'react';
import { useI18n } from '../i18n/LanguageContext';

const INITIAL = {
  firstName: '',
  lastName: '',
  email: '',
  location: '',
  subject: '',
  message: '',
};

export default function ContactUs() {
  const { t } = useI18n();
  const [form, setForm] = useState(INITIAL);
  const [submitting, setSubmitting] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      // wire to backend later
      await new Promise((r) => setTimeout(r, 400));
      setForm(INITIAL);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <div className="contact-inner">
        <div className="contact-intro">
          <div className="about-eyebrow">
            <span className="about-dot" /> {t('contact.eyebrow')}
          </div>
          <h2 className="contact-heading">{t('contact.title')}</h2>
          <p className="contact-text">
            Muri iyo minsi, 26umumalayika wa Nyagasani abwira Filipo ati
            « Haguruka ugende werekeje mu majyepfo, unyuremu muhanda umanuka
            i Yeruzalernu ujya i Gaza, ubu nguhu ukaba utarimo abagenzi.
            »27Filipo ahera ko aragenda
          </p>
        </div>

        <form className="contact-form" onSubmit={handleSubmit} noValidate>
          <div className="contact-row">
            <input
              className="contact-input"
              type="text"
              placeholder={t('contact.first_name')}
              value={form.firstName}
              onChange={update('firstName')}
              required
            />
            <input
              className="contact-input"
              type="text"
              placeholder={t('contact.last_name')}
              value={form.lastName}
              onChange={update('lastName')}
              required
            />
          </div>
          <input
            className="contact-input"
            type="email"
            placeholder={t('contact.email')}
            value={form.email}
            onChange={update('email')}
            required
          />
          <div className="contact-row">
            <input
              className="contact-input"
              type="text"
              placeholder={t('contact.location')}
              value={form.location}
              onChange={update('location')}
            />
            <input
              className="contact-input"
              type="text"
              placeholder={t('contact.subject')}
              value={form.subject}
              onChange={update('subject')}
            />
          </div>
          <textarea
            className="contact-input contact-textarea"
            placeholder={t('contact.message')}
            value={form.message}
            onChange={update('message')}
            rows={5}
            required
          />
          <button className="contact-submit" type="submit" disabled={submitting}>
            {submitting ? t('contact.sending') : t('contact.submit')}
          </button>
        </form>
      </div>
    </section>
  );
}
